import { render, staticRenderFns } from "./ProgramacionIndex.vue?vue&type=template&id=4894c8e2"
import script from "./ProgramacionIndex.vue?vue&type=script&lang=js"
export * from "./ProgramacionIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports